import { dateOptions } from "../config";

const locales = {
    ar: "ar-EG", // Arabic - Egypt
    en: "en-US", // English - US
};

const getLocale = (language) => locales[language] || locales["en"];

export const printFullDate = (date, language = "ar") => {
    return new Date(date).toLocaleDateString(getLocale(language), dateOptions);
};

export const printFullDateTime = (date, language = "ar") => {
    language = language === "ar" ? "ar-EG" : "en-US";
    const dateObject = new Date(date);
    return `${padstart2(dateObject.getHours())}:${padstart2(
        dateObject.getMinutes()
    )} ${dateObject.toLocaleDateString(language, dateOptions)}`;
};

export const printShortDateTime = (date, language = "ar-EG") => {
    language = language === "ar" ? "ar-EG" : "en-US";
    const dateObject = new Date(date);
    return `${padstart2(dateObject.getHours())}:${padstart2(
        dateObject.getMinutes()
    )} ${dateObject.toLocaleDateString(language, {
        weekday: "long",
        month: "short",
        day: "numeric",
    })}`;
};

export const printFullDateTimeInHours = (date, language = "ar") => {
    const dateObject = new Date(date);
    let hours = dateObject.getHours();
    const minutes = padstart2(dateObject.getMinutes());
    const ampm =
        hours >= 12 ? (language === "ar" ? "مساءًا" : "PM") : language === "ar" ? "صباحًا" : "AM";
    hours = hours % 12 || 12;
    return `${padstart2(hours)}:${minutes} ${ampm}`;
};

export const padstart2 = (value) => {
    return `${value}`.padStart("2", "0");
};
export const printDateTime = (datetime = Date.now()) => {
    const date = new Date(datetime);
    return `${date.getFullYear()}-${padstart2(date.getMonth() + 1)}-${padstart2(
        date.getDate()
    )}T${padstart2(date.getHours())}:${padstart2(date.getMinutes())}`;
};

export function getDatesInRange(startDate, endDate) {
    const dates = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
}
